<template>
  <div class="show-answer">
    {{ responses.percentage }} <span class="fa fa-bullhorn answer" />

    <template v-for="answer in answers">
      {{ answer.percentage }} <span
        class="answer"
        :class="getIconClass(answer.answer)"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: 'LikeQuestionResult',
  props: {
    answers: { required: true },
    responses: { required: true },
  },
  methods: {
    getIconClass (answer) {
      return answer == 'agree' ? 'icon-like' : 'icon-dislike'
    },
  },
}
</script>

<style scoped>
    .answer {
        margin-right: 20px;
    }

    .show-answer {
        display: inline-block;
    }
</style>
